'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index$2 = require('../Icon/index.js');
var timeFormatTranslation = require('../../transformers/timeFormatTranslation.js');
var LocationCard_module = require('./LocationCard.module.css.js');
var index$1 = require('../Language/index.js');
var index = require('../TextLink/index.js');
var SelectItem = require('../SelectItem/SelectItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const DistanceItemC = _ref => {
  var _location$address, _location$address2, _location$address3, _location$address4, _location$address5, _location$address6, _location$distance, _location$distance$va, _location$distance2, _location$distance3;
  let {
    location
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const hasExactLocation = location.latitude && location.longitude && location.distance;
  if (!hasExactLocation && !location.address) return null;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationCard_module["default"].locationItemDistance
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    href: `https://maps.google.com/?q=${encodeURIComponent([location.displayName, location === null || location === void 0 ? void 0 : (_location$address = location.address) === null || _location$address === void 0 ? void 0 : _location$address.address1, location === null || location === void 0 ? void 0 : (_location$address2 = location.address) === null || _location$address2 === void 0 ? void 0 : _location$address2.address2, location === null || location === void 0 ? void 0 : (_location$address3 = location.address) === null || _location$address3 === void 0 ? void 0 : _location$address3.city, location === null || location === void 0 ? void 0 : (_location$address4 = location.address) === null || _location$address4 === void 0 ? void 0 : _location$address4.regionCode, location === null || location === void 0 ? void 0 : (_location$address5 = location.address) === null || _location$address5 === void 0 ? void 0 : _location$address5.countryCode, location === null || location === void 0 ? void 0 : (_location$address6 = location.address) === null || _location$address6 === void 0 ? void 0 : _location$address6.postalCode].filter(Boolean).join(' '))}`,
    target: "_blank",
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    }
  }, hasExactLocation && `${(location === null || location === void 0 ? void 0 : (_location$distance = location.distance) === null || _location$distance === void 0 ? void 0 : (_location$distance$va = _location$distance.value) === null || _location$distance$va === void 0 ? void 0 : _location$distance$va.toFixed(1)) ?? ''} `, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: (_location$distance2 = location.distance) !== null && _location$distance2 !== void 0 && _location$distance2.unit ? `returnsPudoLocationsDistanceUnit${(_location$distance3 = location.distance) === null || _location$distance3 === void 0 ? void 0 : _location$distance3.unit.toLowerCase()}` : 'returnsPudoLocationsDistanceNounit'
  })));
};
const DistanceItem = nthHookTheme.withThemeProvider(DistanceItemC, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});
const AddressItem = _ref2 => {
  let {
    location: {
      address
    }
  } = _ref2;
  return address ? /*#__PURE__*/React__default["default"].createElement("address", {
    className: LocationCard_module["default"].locationItemAddress
  }, [address.address1, address.address2, address.city, address.regionCode].filter(Boolean).join(', '), ` ${address.postalCode}`) : null;
};
const LocationCardC = _ref3 => {
  var _location$logoUrls;
  let {
    location,
    active,
    onValueChange,
    transparent
  } = _ref3;
  const {
    bodytextDefaultNone,
    headersSmallNone,
    panelcontainerNoneNone
  } = nthHookTheme.useTheme();
  const openingHoursDisplay = location.openingHoursDisplayString || (location.openingHours ? timeFormatTranslation["default"](location.openingHours) : '');
  return /*#__PURE__*/React__default["default"].createElement(SelectItem["default"], {
    customStyle: {
      display: 'grid',
      width: '100%',
      gridAutoFlow: 'row',
      gridTemplateColumns: 'auto 1fr auto',
      alignItems: 'center',
      justifyContent: 'start',
      gridColumnGap: '32px',
      gridRowGap: '5px',
      gridTemplateAreas: active ? `
            'Icon Title Distance'
            'Icon Subtitle Distance'
            'Icon Address .'
            'Icon Details Details'
          ` : `'Icon Title Distance'`,
      fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px',
      ...panelcontainerNoneNone
    },
    value: location.id,
    key: location.id,
    onClick: () => onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(location.id),
    selected: active,
    transparent: transparent,
    readOnly: transparent,
    borderless: transparent
  }, ((_location$logoUrls = location.logoUrls) === null || _location$logoUrls === void 0 ? void 0 : _location$logoUrls.length) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationCard_module["default"].locationItemIcon
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    alt: location.displayName || (location === null || location === void 0 ? void 0 : location.storeName) || location.id,
    src: location.logoUrls[0],
    style: {
      width: '100%'
    }
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationCard_module["default"].locationItemTitle,
    style: {
      fontSize: (headersSmallNone === null || headersSmallNone === void 0 ? void 0 : headersSmallNone.fontSize) ?? '14px'
    }
  }, location.displayName || location.storeName), active && location.locationType && /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationCard_module["default"].locationItemSubtitle
  }, location.locationType), active && /*#__PURE__*/React__default["default"].createElement(AddressItem, {
    location: location
  }), active && openingHoursDisplay && /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationCard_module["default"].locationItemHours
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    icon: "Clock",
    style: {
      alignSelf: 'center'
    }
  }), openingHoursDisplay), /*#__PURE__*/React__default["default"].createElement(DistanceItem, {
    location: location
  }));
};
var LocationCard = nthHookTheme.withThemeProvider(LocationCardC, {
  themeTokens: ['documentbodyNoneNone', 'bodytextDefaultNone', 'headersSmallNone', 'linksNoneDefault', 'linksNoneHover', 'panelcontainerNoneNone', 'selecteditemNoneNone']
});

exports["default"] = LocationCard;
